/** Normaliza `adjuntosInfo` del API (JSON array de { url, nombre, mime? }). */
export function parseAcuerdoAdjuntosInfo(raw) {
  if (raw == null) return [];
  let a = raw;
  if (typeof a === 'string') {
    try {
      a = JSON.parse(a);
    } catch {
      return [];
    }
  }
  if (!Array.isArray(a)) return [];
  return a
    .map((x) => {
      if (!x || typeof x !== 'object') return null;
      const url = typeof x.url === 'string' ? x.url.trim() : '';
      const nombre = typeof x.nombre === 'string' ? x.nombre.trim() : '';
      if (!url || !nombre) return null;
      const mime = typeof x.mime === 'string' ? x.mime.trim() : undefined;
      return { url, nombre, mime };
    })
    .filter(Boolean);
}
